<template>
  <div class="container allusers" style="min-height: 700px;">
    <div class="row margin-bottom-10 margin-top-20 mybookings-header">
      <div class="col-12">
        <div class="card afas-gold">
          <div class="card-content">
            <h5 class="margin-top-10 margin-bottom-10 white-text">All Users</h5>
            <a
              class="waves-effect waves-light white teal-text btn-small btn-block back-button"
              @click="goBack"
            >Go Back</a>
          </div>
        </div>
      </div>
    </div>
    <div class="progress" v-if="loading">
      <div class="indeterminate"></div>
    </div>
    <div class="row calendar-card card margin-top-10" v-if="!loading">
      <div class="col-12 card-content">
        <div class="row">
          <div class="col-12">
            <table class="striped highlight responsive-table">
              <thead>
                <th class="center">#</th>
                <th>E-Mail</th>
                <th>Permission</th>
              </thead>
              <tbody>
                <tr class="scale-transition" v-for="(user, index) in allUsers" :key="user.id">
                  <td width="50px" class="center">{{ index + 1 }}</td>
                  <td>{{ user.email }}</td>
                  <td width="200px">
                    <div class="input-field">
                      <select class="browser-default" v-model="user.permission" @change="changePermission(user.id, user.permission)" :disabled="processing">
                        <option value="100">User</option>
                        <option value="200">Secretary</option>
                        <option value="300">Arthur</option>
                        <option value="900">Admin</option>
                      </select>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Admin",
  data() {
    return {
      loading: true,
      processing: false,
    };
  },
  computed: {
    ...mapGetters(["allUsers"]),
  },
  methods: {
    ...mapActions(["getAllUsers", "changeUserPermission"]),
    goBack() {
      this.$router.go(-1);
    },
    async changePermission(userid, userpermission){
      this.processing = true;
      var info = {
        userid: userid,
        permission:userpermission
      }
      await this.changeUserPermission(info);
      this.processing = false;
    }
  },
  async mounted() {
    await this.getAllUsers();
    this.loading = false;
  },
};
</script>

<style scoped>
.calendar-card {
  position: relative;
}

.mybookings-header .back-button {
  position: absolute;
  top: 15px;
  right: 15px;
}

.delete-icon {
  cursor: pointer;
}

.delete-icon:hover {
  color: grey;
}

.just-deleted {
  text-decoration: line-through;
  background-color: rgba(255, 0, 0, 0.3);
}

.allusers td {
  padding-top: 0;
  padding-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/Admin.vue